import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { store } from './app/store';
import { createAppRouter } from './routing/buildAppRouter';
import { UserProvider } from './contexts/UserContext';
import { AlertProvider } from './alert/AlertContext';
import { ColorModeProvider } from './contexts/ColorModeContext';
import { loadFacilities } from './feature/facilitiesSlice';
import authService from './auth/auth-service';

const router = createAppRouter();

const App: React.FC = () => {
  useEffect(() => {
    if (authService.loggedIn()) {
      store.dispatch(loadFacilities);
    }
  }, []);

  return (
    <ColorModeProvider>
      <ReduxProvider store={store}>
        <AlertProvider>
          <UserProvider
            initialUser={authService.loggedIn() ? authService.currentUser() : null}>
            <RouterProvider
              router={router}
              future={{ v7_startTransition: true }}
            />
          </UserProvider>
        </AlertProvider>
      </ReduxProvider>
    </ColorModeProvider>
  );
};

export default App;
